/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../../types";

export const sageGraysTheme: OrganizationTheme = {
  id: "sage-grays",
  name: "Sage Grays",
  description: "Sophisticated, modern palette with sage greens and cool grays",
  recommendedFor: [
    "Modern Construction",
    "Commercial Projects",
    "Tech-Forward Companies",
    "Clean Design",
  ],

  colors: {
    primary: {
      name: "Deep Sage",
      hex: "#384D48",
      hsl: "166 16% 27%",
      rgb: [56, 77, 72],
    },
    primaryForeground: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    secondary: {
      name: "Olive Mist",
      hex: "#ACAD94",
      hsl: "62 11% 63%",
      rgb: [172, 173, 148],
    },
    secondaryForeground: {
      name: "Deep Sage",
      hex: "#384D48",
      hsl: "166 16% 27%",
      rgb: [56, 77, 72],
    },
    muted: {
      name: "Light Gray",
      hex: "#F5F5F5",
      hsl: "0 0% 96%",
      rgb: [245, 245, 245],
    },
    mutedForeground: {
      name: "Medium Gray",
      hex: "#666666",
      hsl: "0 0% 40%",
      rgb: [102, 102, 102],
    },
    card: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    cardForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    background: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    foreground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
  },

  cssVariables: {
    "--primary": "166 16% 27%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "62 11% 63%",
    "--secondary-foreground": "166 16% 27%",
    "--muted": "0 0% 96%",
    "--muted-foreground": "0 0% 40%",
    "--card": "0 0% 100%",
    "--card-foreground": "0 0% 12%",
    "--background": "0 0% 100%",
    "--foreground": "0 0% 12%",
    // Semantic colors — muted, understated alongside sage/olive
    "--success": "155 45% 38%",
    "--success-foreground": "0 0% 98%",
    "--warning": "36 65% 48%",
    "--warning-foreground": "0 0% 12%",
    "--error": "3 60% 45%",
    "--error-foreground": "0 0% 98%",
    "--info": "212 45% 48%",
    "--info-foreground": "0 0% 98%",
    "--destructive": "3 60% 45%",
    "--destructive-foreground": "0 0% 98%",
    // Sidebar / warm surface — subtle tint of secondary hue
    "--background-warm": "62 10% 98%",
    "--background-warm-alt": "62 8% 96%",
    // Extended palette — muted, sophisticated accents for sage/gray base
    "--palette-violet": "255 35% 50%",
    "--palette-teal": "180 40% 38%",
    "--palette-pink": "335 40% 50%",
    "--palette-orange": "22 65% 50%",
    "--palette-sky": "198 50% 45%",
  },
};
